/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui"
import React from 'react'
import { Box, Flex } from '@theme-ui/components'
import styled from '@emotion/styled'
import moment from 'moment'
import { colors, typography } from "../../styles/theme"
import { InfoTile } from "../molecules"

const {
  fontSize,
  fontStyle,
  fontWeight,
  lineHeight,
  fontFamily,
  color
} = typography.textMd400;

const AttachmentsList = ({ attachments }) => {
  return (
    <Flex sx={{ flexDirection: 'row', flexWrap: 'wrap', }}>
      {attachments && attachments.nodes.map((stAttachment, index) => {
        const attachment = stAttachment.attachment ?
             {file:stAttachment.attachment.filename,url:stAttachment.attachment.url}:
             stAttachment.attachmentFileName ?
             {file:stAttachment.attachmentFileName,url:stAttachment.attachmentUrl} : null;
        return (
          <InfoTile
            key={`attachmnet-${index}`}
            variant="default"
            title={`Download: ${stAttachment.name}`}
            buttonLabel="Download PDF"
            iconName='FileDown' 
            theme='secondaryGreen'
            btnVariant='filled'
            onBtnClick={() => {
              attachment && window.open(attachment.url, '_blank', 'noopener,noreferrer');
            }}
            customStyles={attachmentDownloadStyles}
          />
        )
      })}
    </Flex>
  )
}

const attachmentDownloadStyles = { 
  mt: '3rem',
  '@media (max-width: 900px)': {
    m: '0 auto',
    mt: '3rem',
  },
}

const StyledTable = styled.table`
  border-radius: 10px;
  overflow: hidden;
  border-collapse: collapse;
  width: 100%;
`;

const Cell = styled.td`
  border-top: 1px solid ${colors.neutral200};
  font-size: ${fontSize};
  font-style: ${fontStyle};
  font-weight: ${fontWeight};
  line-height: ${lineHeight};
  font-family: ${fontFamily};
  color: ${color};
  min-width: 6.875rem;
  ${(props) => (props.lastInRow ? 'border-right: none;' : `border-right: 1px solid ${colors.neutral200};`)}
`;

const HolidayList = ({ items, attachments }) => {
  const formattedDate = (date) => moment(date, "YYYY-MM-DD").format('MMM D');

  return (
    <>
      <Box sx={containerStyles}>
        <Box sx={innerBoxStyles}>
          <StyledTable>
            <thead sx={tableHeaderStyles}>
              <tr>
                <Cell sx={cellHeaderStyles}>Date</Cell>
                <Cell sx={cellDayStyles}>Day</Cell>
                <Cell sx={cellDayStyles} lastInRow={items[0].HolidayType ? false : true}>Holiday</Cell>
                {items[0]?.HolidayType && (
                  <Cell sx={cellHolidayTypeStyles} lastInRow={true}>
                    Holiday Type
                  </Cell>
                )}
              </tr>
            </thead>
            <tbody>
              {items.map((holiday, index) => (
                <tr key={`cell-${index}`}>
                  <Cell sx={cellDateStyles}>{formattedDate(holiday.Date)}</Cell>
                  <Cell sx={cellHolidayStyles}>{holiday.Day}</Cell>
                  <Cell sx={cellHolidayStyles} lastInRow={holiday.HolidayType ? false : true}>{holiday.Holiday}</Cell>
                  {holiday?.HolidayType && (
                    <Cell sx={cellHolidayTypeStyles} lastInRow={true}>
                      {holiday?.HolidayType}
                    </Cell>
                  )}
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </Box>
      </Box>

      <AttachmentsList attachments={attachments} />
    </>
  )
}

const {containerStyles, innerBoxStyles, tableHeaderStyles, cellHeaderStyles, cellDayStyles, cellHolidayStyles, cellDateStyles, cellHolidayTypeStyles} = {
  containerStyles: {
    overflowX: 'auto',
  },
  innerBoxStyles: {
    width: ['52rem', '52rem', '52rem', '100%'],
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '10px',
  },
  tableHeaderStyles: {
    backgroundColor: colors.neutral200,
  },
  cellHeaderStyles: {
    p: '1rem',
    borderRight: `1px solid ${colors.neutral300}`,
  },
  cellDayStyles: {
    p: '1rem 1.5rem',
    borderRight: `1px solid ${colors.neutral300}`,
  },
  cellDateStyles: {
    p: '1rem',
  },
  cellHolidayStyles: {
    p: '1rem 1.5rem',
  },
  cellHolidayTypeStyles: {
    p: '1rem 1.5rem',
  }
}

export default HolidayList;
